import { useTranslation } from 'react-i18next';

export const useHomepageTDK = (): { title: string; description: string; keywords: string } => {
  const { t } = useTranslation();

  const keywords = [t('web_text_1'), t('web_text_2'), t('web_text_3'), 'Lemon8'].join(', ');

  return {
    title: t('web_tab_name'),
    keywords,
    description: t('web_google_seo'),
  };
};
